/*
 * @Author: calebman
 * @Date: 2018-05-09 09:36:36
 * @Last Modified by: calebman
 * @Last Modified time: 2018-05-09 14:47:06
 */

/**
 * 使用 sessionStorage 存储 token 值
 *
 * SECURITY NOTE: sessionStorage 比 localStorage 更安全，因为：
 * 1. sessionStorage 数据在浏览器标签页关闭后自动清除，减少 token 泄露窗口期
 * 2. localStorage 持久化存储，XSS 攻击可窃取长期有效的 token
 * 3. access token 仍使用 sessionStorage；长期刷新凭证由 HttpOnly + Secure cookie 承担
 *
 * Web admin auto-login uses an HttpOnly refresh cookie now.
 * Do not store long-lived ptoken values in localStorage.
 */


import { readMenuTree } from '@/utils/menuCache.mjs';

import { STORAGE_KEYS } from '@/constants/app';
import {
    ACCESS_TOKEN_ACTIVITY_TTL_MS,
    ACCESS_TOKEN_INITIAL_TTL_MS,
    getAccessTokenState,
    isAccessTokenKnownExpired,
    shouldRefreshAccessToken
} from '@/utils/authSession.mjs';

const tokenKey = STORAGE_KEYS.token

export function getRouterTree() {
    return readMenuTree();
}
export function isMacAuth(id) {
    let macbigtypeids = window.localStorage.getItem("macBigTypeIds")
    let res = false;
    if ((!macbigtypeids || typeof (macbigtypeids) == "undefined" || macbigtypeids == "" || macbigtypeids == "null"))
        return false;
    macbigtypeids = macbigtypeids.split(',');
    macbigtypeids.forEach(element => {
        if (element == id) {
            res = true;
        }
    });
    return res;
}

export function getToken() {
    return window.sessionStorage.getItem(tokenKey);
}

export function getTokenExpiresAt() {
    const value = Number(window.sessionStorage.getItem(STORAGE_KEYS.tokenExpiresAt));
    return Number.isFinite(value) && value > 0 ? value : null;
}

export function getCurrentAccessTokenState(now = Date.now()) {
    return getAccessTokenState(getToken(), getTokenExpiresAt(), now);
}

export function shouldRefreshCurrentAccessToken(now = Date.now()) {
    return shouldRefreshAccessToken(getToken(), getTokenExpiresAt(), now);
}

export function isCurrentAccessTokenExpired(now = Date.now()) {
    return isAccessTokenKnownExpired(getToken(), getTokenExpiresAt(), now);
}

export function isMo() {//是否为超级总机构（moid==oid）
    const userMoid = window.localStorage.getItem("moid");
    const userOid = window.localStorage.getItem("oid");
    if (userMoid > 0 && userMoid == userOid)
        return true;
    else
        return false;
}

export function isAllMo() {//是否为根机构（id==1）
    const userOid = window.localStorage.getItem("oid");
    return userOid == 1 && !isStandaloneCustomer();
}
/** 与登录接口 info.isMain 一致（工厂端 / 测试工厂 moid）；仅 localStorage 的 "true" / "1" 为真 */
export function isStandaloneCustomer() {
    return window.localStorage.getItem('isStandaloneCustomer') === '1'
        || window.__AUTOMACHINE_DEPLOYMENT__?.CUSTOMER_PROFILE === true;
}
export function isMain() {
    const v = window.localStorage.getItem("isMain");
    if (v == null || v === "") {
        return false;
    }
    if (v === "false" || v === "0" || v === "null" || v === "undefined") {
        return false;
    }
    return v === "true" || v === "1" || v === "True";
}
/** 当前账号是否为所属机构的总管理员（role.ismain=1，与 OrgUiConfig 一致） */
export function isOrgMainAdmin() {
    const v = window.localStorage.getItem("ismain");
    if (v == null || v === "") {
        return false;
    }
    return Number(v) === 1;
}
export function setToken(token, ttlMs = ACCESS_TOKEN_INITIAL_TTL_MS) {
    window.sessionStorage.setItem(tokenKey, token);
    window.sessionStorage.setItem(STORAGE_KEYS.tokenExpiresAt, String(Date.now() + ttlMs));
    return token;
}

export function touchTokenExpiry(ttlMs = ACCESS_TOKEN_ACTIVITY_TTL_MS) {
    if (empty(getToken())) {
        return null;
    }
    const expiresAt = Date.now() + ttlMs;
    window.sessionStorage.setItem(STORAGE_KEYS.tokenExpiresAt, String(expiresAt));
    return expiresAt;
}

export function removeToken() {
    window.sessionStorage.removeItem(tokenKey);
    window.sessionStorage.removeItem(STORAGE_KEYS.tokenExpiresAt);
}

export function empty(exp) {
    return (!exp || typeof (exp) == "undefined" || exp == "" || exp == "null") && !(exp === 0);
}

export function getAuth(path) {
    const routerst = getRouterTree();
    for (const r of routerst) {
        for (const e of (r.child || [])) {
            if (e.links == path) {
                return e.auths;
            }
        }
    }
    return 0;
}
export function getAuthPageId(id) {
    const routerst = getRouterTree();
    for (const r of routerst) {
        for (const e of (r.child || [])) {
            if (e.id == id) {
                return e.auths;
            }
        }
    }
    return 0;
}
export function getWriteAuth(mthis) {
    const routerst = getRouterTree();
    let path = mthis.$route.path
    const permissionPathAliases = {
        "/jiqidetails": "/machine",
        "/machaisle": "/machine",
        "/hangar": "/goods",
        "/warehouse_reper": "/warehouse",
        "/role_editor": "/role",
        "/role_mage": "/role",
    };
    path = permissionPathAliases[path] || path;

    for (const r of routerst) {
        for (const e of (r.child || [])) {
            if (e.links == path) {
                return e.auths == 7;
            }
        }
    }
    return false;
}

export function randomString(len) {
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}
